var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    viewBox: "0 0 406 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.508 55.1294C312.675 30.3625 293.446 7.86611 269.259 2.20402C247.409 -2.91656 224.608 4.70256 202.226 2.99253C193.533 2.31802 184.983 0.246989 176.271 0.0284854C166.701 -0.140083 157.22 1.89345 148.56 5.97203C139.901 10.0506 132.294 16.0651 126.329 23.5509C112.402 41.3067 102.854 63.309 100.441 85.7579C93.183 154.634 67.5231 171.848 64.4355 191.495C52.5033 267.325 130.405 302.722 192.251 305.848C248.672 308.698 324.075 273.015 333.546 260.903C347.265 243.375 343.275 199.389 337.128 178.004C332.207 160.904 324.578 143.804 323.125 125.868C321.918 111 323.324 102.231 317.472 87.5059C313.387 77.2268 315.306 65.8741 314.508 55.1294Z",
    fill: "#FAEDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.819 114.325C319.821 119.23 318.857 124.088 316.981 128.621C315.105 133.153 312.355 137.272 308.887 140.741C305.418 144.21 301.301 146.961 296.769 148.838C292.236 150.715 287.379 151.681 282.474 151.679H142.821C133.051 151.721 123.654 147.93 116.647 141.121C109.639 134.313 105.58 125.029 105.34 115.261C105.1 105.494 108.699 96.0215 115.363 88.877C122.028 81.7324 131.227 77.4851 140.988 77.0463C142.446 68.7165 146.793 61.1671 153.265 55.7239C159.737 50.2807 167.919 47.2918 176.376 47.2823H181.173C189.522 47.2899 197.609 50.1905 204.059 55.4904C207.739 46.1264 214.571 38.3405 223.378 33.4761C232.185 28.6117 242.414 26.9739 252.299 28.8453C262.184 30.7168 271.107 35.9801 277.526 43.7271C283.945 51.474 287.459 61.2187 287.461 71.2797C287.485 73.2925 287.316 75.303 286.958 77.2838C296.015 78.3751 304.36 82.7461 310.415 89.5709C316.469 96.3956 319.814 105.202 319.819 114.325Z",
    fill: "#FFC063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.819 114.325C319.821 119.23 318.857 124.088 316.981 128.621C315.105 133.153 312.355 137.272 308.887 140.741C305.418 144.21 301.301 146.961 296.769 148.838C292.236 150.715 287.379 151.681 282.474 151.679H142.821C133.051 151.721 123.654 147.93 116.647 141.121C109.639 134.313 105.58 125.029 105.34 115.261C105.1 105.494 108.699 96.0215 115.363 88.877C122.028 81.7324 131.227 77.4851 140.988 77.0463C142.446 68.7165 146.793 61.1671 153.265 55.7239C159.737 50.2807 167.919 47.2918 176.376 47.2823H181.173C189.522 47.2899 197.609 50.1905 204.059 55.4904C207.739 46.1264 214.571 38.3405 223.378 33.4761C232.185 28.6117 242.414 26.9739 252.299 28.8453C262.184 30.7168 271.107 35.9801 277.526 43.7271C283.945 51.474 287.459 61.2187 287.461 71.2797C287.485 73.2925 287.316 75.303 286.958 77.2838C296.015 78.3751 304.36 82.7461 310.415 89.5709C316.469 96.3956 319.814 105.202 319.819 114.325Z",
    fill: "url(#paint0_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.287 103.58C319.285 108.316 318.321 113.001 316.455 117.353C314.588 121.705 311.857 125.633 308.428 128.898C301.37 135.651 291.965 139.397 282.198 139.348H143.496C122.985 139.348 106.35 123.36 106.35 103.552C106.358 98.8173 107.324 94.1335 109.191 89.7824C111.057 85.4312 113.784 81.5029 117.209 78.2338C123.817 71.8794 132.521 68.1624 141.681 67.7836C142.973 60.7679 146.456 54.3422 151.628 49.4293C158.402 42.9086 167.448 39.28 176.851 39.3116H181.601C189.843 39.3038 197.847 42.0788 204.316 47.1873C210.529 31.8065 226.024 20.9003 244.216 20.9003C267.967 20.9003 287.138 39.4351 287.138 62.3305C287.162 64.2615 286.993 66.19 286.635 68.0876C305.046 70.2061 319.287 85.2829 319.287 103.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.761 109.157C132.761 107.976 131.804 107.019 130.623 107.019C129.443 107.019 128.486 107.976 128.486 109.157V123.065C128.486 124.246 129.443 125.203 130.623 125.203C131.804 125.203 132.761 124.246 132.761 123.065V109.157Z",
    fill: "url(#paint1_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 109.157C141.501 107.976 140.544 107.019 139.363 107.019C138.183 107.019 137.226 107.976 137.226 109.157V123.065C137.226 124.246 138.183 125.203 139.363 125.203C140.544 125.203 141.501 124.246 141.501 123.065V109.157Z",
    fill: "url(#paint2_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.241 109.157C150.241 107.976 149.284 107.019 148.103 107.019C146.923 107.019 145.966 107.976 145.966 109.157V123.065C145.966 124.246 146.923 125.203 148.103 125.203C149.284 125.203 150.241 124.246 150.241 123.065V109.157Z",
    fill: "url(#paint3_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.696 109.157C177.696 107.976 176.739 107.019 175.559 107.019C174.378 107.019 173.421 107.976 173.421 109.157V123.065C173.421 124.246 174.378 125.203 175.559 125.203C176.739 125.203 177.696 124.246 177.696 123.065V109.157Z",
    fill: "url(#paint4_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.436 109.157C186.436 107.976 185.479 107.019 184.299 107.019C183.118 107.019 182.161 107.976 182.161 109.157V123.065C182.161 124.246 183.118 125.203 184.299 125.203C185.479 125.203 186.436 124.246 186.436 123.065V109.157Z",
    fill: "url(#paint5_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.177 109.157C195.177 107.976 194.22 107.019 193.039 107.019C191.859 107.019 190.902 107.976 190.902 109.157V123.065C190.902 124.246 191.859 125.203 193.039 125.203C194.22 125.203 195.177 124.246 195.177 123.065V109.157Z",
    fill: "url(#paint6_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.412 109.157C238.412 107.976 237.455 107.019 236.274 107.019C235.094 107.019 234.137 107.976 234.137 109.157V123.065C234.137 124.246 235.094 125.203 236.274 125.203C237.455 125.203 238.412 124.246 238.412 123.065V109.157Z",
    fill: "url(#paint7_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.152 109.157C247.152 107.976 246.195 107.019 245.014 107.019C243.834 107.019 242.877 107.976 242.877 109.157V123.065C242.877 124.246 243.834 125.203 245.014 125.203C246.195 125.203 247.152 124.246 247.152 123.065V109.157Z",
    fill: "url(#paint8_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.892 109.157C255.892 107.976 254.935 107.019 253.754 107.019C252.574 107.019 251.617 107.976 251.617 109.157V123.065C251.617 124.246 252.574 125.203 253.754 125.203C254.935 125.203 255.892 124.246 255.892 123.065V109.157Z",
    fill: "url(#paint9_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.348 109.157C283.348 107.976 282.391 107.019 281.21 107.019C280.03 107.019 279.073 107.976 279.073 109.157V123.065C279.073 124.246 280.03 125.203 281.21 125.203C282.391 125.203 283.348 124.246 283.348 123.065V109.157Z",
    fill: "url(#paint10_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.088 109.157C292.088 107.976 291.131 107.019 289.95 107.019C288.77 107.019 287.813 107.976 287.813 109.157V123.065C287.813 124.246 288.77 125.203 289.95 125.203C291.131 125.203 292.088 124.246 292.088 123.065V109.157Z",
    fill: "url(#paint11_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.828 109.157C300.828 107.976 299.871 107.019 298.69 107.019C297.51 107.019 296.553 107.976 296.553 109.157V123.065C296.553 124.246 297.51 125.203 298.69 125.203C299.871 125.203 300.828 124.246 300.828 123.065V109.157Z",
    fill: "url(#paint12_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.761 229.334C132.761 228.153 131.804 227.196 130.623 227.196C129.443 227.196 128.486 228.153 128.486 229.334V243.242C128.486 244.423 129.443 245.38 130.623 245.38C131.804 245.38 132.761 244.423 132.761 243.242V229.334Z",
    fill: "url(#paint13_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 229.334C141.501 228.153 140.544 227.196 139.363 227.196C138.183 227.196 137.226 228.153 137.226 229.334V243.242C137.226 244.423 138.183 245.38 139.363 245.38C140.544 245.38 141.501 244.423 141.501 243.242V229.334Z",
    fill: "url(#paint14_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.241 229.334C150.241 228.153 149.284 227.196 148.103 227.196C146.923 227.196 145.966 228.153 145.966 229.334V243.242C145.966 244.423 146.923 245.38 148.103 245.38C149.284 245.38 150.241 244.423 150.241 243.242V229.334Z",
    fill: "url(#paint15_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.696 229.334C177.696 228.153 176.739 227.196 175.559 227.196C174.378 227.196 173.421 228.153 173.421 229.334V243.242C173.421 244.423 174.378 245.38 175.559 245.38C176.739 245.38 177.696 244.423 177.696 243.242V229.334Z",
    fill: "url(#paint16_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.436 229.334C186.436 228.153 185.479 227.196 184.299 227.196C183.118 227.196 182.161 228.153 182.161 229.334V243.242C182.161 244.423 183.118 245.38 184.299 245.38C185.479 245.38 186.436 244.423 186.436 243.242V229.334Z",
    fill: "url(#paint17_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.177 229.334C195.177 228.153 194.22 227.196 193.039 227.196C191.859 227.196 190.902 228.153 190.902 229.334V243.242C190.902 244.423 191.859 245.38 193.039 245.38C194.22 245.38 195.177 244.423 195.177 243.242V229.334Z",
    fill: "url(#paint18_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.412 229.334C238.412 228.153 237.455 227.196 236.274 227.196C235.094 227.196 234.137 228.153 234.137 229.334V243.242C234.137 244.423 235.094 245.38 236.274 245.38C237.455 245.38 238.412 244.423 238.412 243.242V229.334Z",
    fill: "url(#paint19_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.152 229.334C247.152 228.153 246.195 227.196 245.014 227.196C243.834 227.196 242.877 228.153 242.877 229.334V243.242C242.877 244.423 243.834 245.38 245.014 245.38C246.195 245.38 247.152 244.423 247.152 243.242V229.334Z",
    fill: "url(#paint20_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.892 229.334C255.892 228.153 254.935 227.196 253.754 227.196C252.574 227.196 251.617 228.153 251.617 229.334V243.242C251.617 244.423 252.574 245.38 253.754 245.38C254.935 245.38 255.892 244.423 255.892 243.242V229.334Z",
    fill: "url(#paint21_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.348 229.334C283.348 228.153 282.391 227.196 281.21 227.196C280.03 227.196 279.073 228.153 279.073 229.334V243.242C279.073 244.423 280.03 245.38 281.21 245.38C282.391 245.38 283.348 244.423 283.348 243.242V229.334Z",
    fill: "url(#paint22_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.088 229.334C292.088 228.153 291.131 227.196 289.95 227.196C288.77 227.196 287.813 228.153 287.813 229.334V243.242C287.813 244.423 288.77 245.38 289.95 245.38C291.131 245.38 292.088 244.423 292.088 243.242V229.334Z",
    fill: "url(#paint23_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.828 229.334C300.828 228.153 299.871 227.196 298.69 227.196C297.51 227.196 296.553 228.153 296.553 229.334V243.242C296.553 244.423 297.51 245.38 298.69 245.38C299.871 245.38 300.828 244.423 300.828 243.242V229.334Z",
    fill: "url(#paint24_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.335 47.1873L214.082 57.2669C214.082 57.2669 220.143 20.9288 258.305 23.3894C258.305 23.3894 222.395 10.7162 204.335 47.1873Z",
    fill: "url(#paint25_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.71 67.8406C141.71 67.8406 148.645 67.0806 155.238 75.0987C155.238 75.0987 156.663 42.6462 184.213 42.1142C184.213 42.1142 172.927 34.9035 157.204 45.0592C143.116 54.1794 141.71 67.8406 141.71 67.8406Z",
    fill: "url(#paint26_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 125.07H125.987C120.179 125.07 115.47 129.778 115.47 135.586V147.081C115.47 152.89 120.179 157.598 125.987 157.598H200.706C206.514 157.598 211.222 152.89 211.222 147.081V135.586C211.222 129.778 206.514 125.07 200.706 125.07Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 164.353H125.987C120.179 164.353 115.47 169.061 115.47 174.869V186.365C115.47 192.173 120.179 196.881 125.987 196.881H200.706C206.514 196.881 211.222 192.173 211.222 186.365V174.869C211.222 169.061 206.514 164.353 200.706 164.353Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 203.227H125.987C120.179 203.227 115.47 207.936 115.47 213.744V225.239C115.47 231.047 120.179 235.756 125.987 235.756H200.706C206.514 235.756 211.222 231.047 211.222 225.239V213.744C211.222 207.936 206.514 203.227 200.706 203.227Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 125.07H229.767C223.958 125.07 219.25 129.778 219.25 135.586V147.081C219.25 152.89 223.958 157.598 229.767 157.598H304.485C310.294 157.598 315.002 152.89 315.002 147.081V135.586C315.002 129.778 310.294 125.07 304.485 125.07Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 164.353H229.767C223.958 164.353 219.25 169.061 219.25 174.869V186.365C219.25 192.173 223.958 196.881 229.767 196.881H304.485C310.294 196.881 315.002 192.173 315.002 186.365V174.869C315.002 169.061 310.294 164.353 304.485 164.353Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 203.227H229.767C223.958 203.227 219.25 207.936 219.25 213.744V225.239C219.25 231.047 223.958 235.756 229.767 235.756H304.485C310.294 235.756 315.002 231.047 315.002 225.239V213.744C315.002 207.936 310.294 203.227 304.485 203.227Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 125.07H125.987C120.179 125.07 115.47 129.778 115.47 135.586V147.081C115.47 152.89 120.179 157.598 125.987 157.598H200.706C206.514 157.598 211.222 152.89 211.222 147.081V135.586C211.222 129.778 206.514 125.07 200.706 125.07Z",
    fill: "url(#paint27_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 164.353H125.987C120.179 164.353 115.47 169.061 115.47 174.869V186.365C115.47 192.173 120.179 196.881 125.987 196.881H200.706C206.514 196.881 211.222 192.173 211.222 186.365V174.869C211.222 169.061 206.514 164.353 200.706 164.353Z",
    fill: "url(#paint28_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.706 203.227H125.987C120.179 203.227 115.47 207.936 115.47 213.744V225.239C115.47 231.047 120.179 235.756 125.987 235.756H200.706C206.514 235.756 211.222 231.047 211.222 225.239V213.744C211.222 207.936 206.514 203.227 200.706 203.227Z",
    fill: "url(#paint29_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 125.07H229.767C223.958 125.07 219.25 129.778 219.25 135.586V147.081C219.25 152.89 223.958 157.598 229.767 157.598H304.485C310.294 157.598 315.002 152.89 315.002 147.081V135.586C315.002 129.778 310.294 125.07 304.485 125.07Z",
    fill: "url(#paint30_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 164.353H229.767C223.958 164.353 219.25 169.061 219.25 174.869V186.365C219.25 192.173 223.958 196.881 229.767 196.881H304.485C310.294 196.881 315.002 192.173 315.002 186.365V174.869C315.002 169.061 310.294 164.353 304.485 164.353Z",
    fill: "url(#paint31_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.485 203.227H229.767C223.958 203.227 219.25 207.936 219.25 213.744V225.239C219.25 231.047 223.958 235.756 229.767 235.756H304.485C310.294 235.756 315.002 231.047 315.002 225.239V213.744C315.002 207.936 310.294 203.227 304.485 203.227Z",
    fill: "url(#paint32_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.934 118.562H126.215C120.407 118.562 115.698 123.27 115.698 129.079V140.574C115.698 146.382 120.407 151.09 126.215 151.09H200.934C206.742 151.09 211.45 146.382 211.45 140.574V129.079C211.45 123.27 206.742 118.562 200.934 118.562Z",
    fill: "#FFFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.934 157.845H126.215C120.407 157.845 115.698 162.554 115.698 168.362V179.857C115.698 185.665 120.407 190.374 126.215 190.374H200.934C206.742 190.374 211.45 185.665 211.45 179.857V168.362C211.45 162.554 206.742 157.845 200.934 157.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.934 196.72H126.215C120.407 196.72 115.698 201.428 115.698 207.236V218.732C115.698 224.54 120.407 229.248 126.215 229.248H200.934C206.742 229.248 211.45 224.54 211.45 218.732V207.236C211.45 201.428 206.742 196.72 200.934 196.72Z",
    fill: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.713 118.562H229.995C224.187 118.562 219.478 123.27 219.478 129.079V140.574C219.478 146.382 224.187 151.09 229.995 151.09H304.713C310.522 151.09 315.23 146.382 315.23 140.574V129.079C315.23 123.27 310.522 118.562 304.713 118.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.713 157.845H229.995C224.187 157.845 219.478 162.554 219.478 168.362V179.857C219.478 185.665 224.187 190.374 229.995 190.374H304.713C310.522 190.374 315.23 185.665 315.23 179.857V168.362C315.23 162.554 310.522 157.845 304.713 157.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.713 196.72H229.995C224.187 196.72 219.478 201.428 219.478 207.236V218.732C219.478 224.54 224.187 229.248 229.995 229.248H304.713C310.522 229.248 315.23 224.54 315.23 218.732V207.236C315.23 201.428 310.522 196.72 304.713 196.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 135.586H210.966V126.903C210.966 126.903 210.434 119.588 200.934 118.562H124.572C124.572 118.562 113.067 121.279 115.48 135.586Z",
    fill: "url(#paint33_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25 135.586H314.707V126.903C314.707 126.903 314.185 119.588 304.685 118.562H228.351C228.351 118.562 216.856 121.279 219.25 135.586Z",
    fill: "url(#paint34_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 174.831H210.966V166.139C210.966 166.139 210.434 158.824 200.934 157.798H124.572C124.572 157.798 113.067 160.505 115.48 174.831Z",
    fill: "url(#paint35_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25 174.831H314.707V166.139C314.707 166.139 314.185 158.824 304.685 157.798H228.351C228.351 157.798 216.856 160.505 219.25 174.831Z",
    fill: "url(#paint36_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48 214.048H210.966V205.355C210.966 205.355 210.434 198.04 200.934 197.024H124.572C124.572 197.024 113.067 199.731 115.48 214.048Z",
    fill: "url(#paint37_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25 214.048H314.707V205.355C314.707 205.355 314.185 198.04 304.685 197.024H228.351C228.351 197.024 216.856 199.731 219.25 214.048Z",
    fill: "url(#paint38_linear_13_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.172 138.398C172.019 138.398 173.516 136.901 173.516 135.054C173.516 133.207 172.019 131.71 170.172 131.71C168.325 131.71 166.828 133.207 166.828 135.054C166.828 136.901 168.325 138.398 170.172 138.398Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.625 138.398C181.472 138.398 182.969 136.901 182.969 135.054C182.969 133.207 181.472 131.71 179.625 131.71C177.778 131.71 176.281 133.207 176.281 135.054C176.281 136.901 177.778 138.398 179.625 138.398Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.068 138.398C190.915 138.398 192.412 136.901 192.412 135.054C192.412 133.207 190.915 131.71 189.068 131.71C187.221 131.71 185.724 133.207 185.724 135.054C185.724 136.901 187.221 138.398 189.068 138.398Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.79 138.398C283.636 138.398 285.134 136.901 285.134 135.054C285.134 133.207 283.636 131.71 281.79 131.71C279.943 131.71 278.446 133.207 278.446 135.054C278.446 136.901 279.943 138.398 281.79 138.398Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.242 138.398C293.089 138.398 294.586 136.901 294.586 135.054C294.586 133.207 293.089 131.71 291.242 131.71C289.395 131.71 287.898 133.207 287.898 135.054C287.898 136.901 289.395 138.398 291.242 138.398Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.695 138.398C302.542 138.398 304.039 136.901 304.039 135.054C304.039 133.207 302.542 131.71 300.695 131.71C298.848 131.71 297.351 133.207 297.351 135.054C297.351 136.901 298.848 138.398 300.695 138.398Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.172 178.299C172.019 178.299 173.516 176.802 173.516 174.955C173.516 173.108 172.019 171.611 170.172 171.611C168.325 171.611 166.828 173.108 166.828 174.955C166.828 176.802 168.325 178.299 170.172 178.299Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.625 178.299C181.472 178.299 182.969 176.802 182.969 174.955C182.969 173.108 181.472 171.611 179.625 171.611C177.778 171.611 176.281 173.108 176.281 174.955C176.281 176.802 177.778 178.299 179.625 178.299Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.068 178.299C190.915 178.299 192.412 176.802 192.412 174.955C192.412 173.108 190.915 171.611 189.068 171.611C187.221 171.611 185.724 173.108 185.724 174.955C185.724 176.802 187.221 178.299 189.068 178.299Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.79 178.299C283.636 178.299 285.134 176.802 285.134 174.955C285.134 173.108 283.636 171.611 281.79 171.611C279.943 171.611 278.446 173.108 278.446 174.955C278.446 176.802 279.943 178.299 281.79 178.299Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.242 178.299C293.089 178.299 294.586 176.802 294.586 174.955C294.586 173.108 293.089 171.611 291.242 171.611C289.395 171.611 287.898 173.108 287.898 174.955C287.898 176.802 289.395 178.299 291.242 178.299Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.695 178.299C302.542 178.299 304.039 176.802 304.039 174.955C304.039 173.108 302.542 171.611 300.695 171.611C298.848 171.611 297.351 173.108 297.351 174.955C297.351 176.802 298.848 178.299 300.695 178.299Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.172 218.2C172.019 218.2 173.516 216.702 173.516 214.856C173.516 213.009 172.019 211.511 170.172 211.511C168.325 211.511 166.828 213.009 166.828 214.856C166.828 216.702 168.325 218.2 170.172 218.2Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.625 218.2C181.472 218.2 182.969 216.702 182.969 214.856C182.969 213.009 181.472 211.511 179.625 211.511C177.778 211.511 176.281 213.009 176.281 214.856C176.281 216.702 177.778 218.2 179.625 218.2Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.068 218.2C190.915 218.2 192.412 216.702 192.412 214.856C192.412 213.009 190.915 211.511 189.068 211.511C187.221 211.511 185.724 213.009 185.724 214.856C185.724 216.702 187.221 218.2 189.068 218.2Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.79 218.2C283.636 218.2 285.134 216.702 285.134 214.856C285.134 213.009 283.636 211.511 281.79 211.511C279.943 211.511 278.446 213.009 278.446 214.856C278.446 216.702 279.943 218.2 281.79 218.2Z",
    fill: "#70CC40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.242 218.2C293.089 218.2 294.586 216.702 294.586 214.856C294.586 213.009 293.089 211.511 291.242 211.511C289.395 211.511 287.898 213.009 287.898 214.856C287.898 216.702 289.395 218.2 291.242 218.2Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.695 218.2C302.542 218.2 304.039 216.702 304.039 214.856C304.039 213.009 302.542 211.511 300.695 211.511C298.848 211.511 297.351 213.009 297.351 214.856C297.351 216.702 298.848 218.2 300.695 218.2Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_259",
    x1: 212.144,
    y1: 96.0086,
    x2: 222.841,
    y2: 519.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_259",
    x1: 136.722,
    y1: 99.6661,
    x2: 123.175,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_259",
    x1: 145.462,
    y1: 99.6661,
    x2: 131.915,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_259",
    x1: 154.202,
    y1: 99.6661,
    x2: 140.646,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_259",
    x1: 181.658,
    y1: 99.6661,
    x2: 168.111,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_259",
    x1: 190.398,
    y1: 99.6661,
    x2: 176.851,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13_259",
    x1: 199.138,
    y1: 99.6661,
    x2: 185.582,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13_259",
    x1: 242.373,
    y1: 99.6661,
    x2: 228.826,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13_259",
    x1: 251.114,
    y1: 99.6661,
    x2: 237.557,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13_259",
    x1: 259.854,
    y1: 99.6661,
    x2: 246.297,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13_259",
    x1: 287.309,
    y1: 99.6661,
    x2: 273.762,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13_259",
    x1: 296.049,
    y1: 99.6661,
    x2: 282.493,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13_259",
    x1: 304.789,
    y1: 99.6661,
    x2: 291.233,
    y2: 136.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13_259",
    x1: 136.722,
    y1: 219.853,
    x2: 123.175,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13_259",
    x1: 145.462,
    y1: 219.853,
    x2: 131.915,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_13_259",
    x1: 154.202,
    y1: 219.853,
    x2: 140.646,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13_259",
    x1: 181.658,
    y1: 219.853,
    x2: 168.111,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13_259",
    x1: 190.398,
    y1: 219.853,
    x2: 176.851,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13_259",
    x1: 199.138,
    y1: 219.853,
    x2: 185.582,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13_259",
    x1: 242.373,
    y1: 219.853,
    x2: 228.826,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13_259",
    x1: 251.114,
    y1: 219.853,
    x2: 237.557,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13_259",
    x1: 259.854,
    y1: 219.853,
    x2: 246.297,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13_259",
    x1: 287.309,
    y1: 219.853,
    x2: 273.762,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13_259",
    x1: 296.049,
    y1: 219.853,
    x2: 282.493,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_13_259",
    x1: 304.789,
    y1: 219.853,
    x2: 291.233,
    y2: 256.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_13_259",
    x1: 232.113,
    y1: 34.7231,
    x2: 122.092,
    y2: 92.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_13_259",
    x1: 169.526,
    y1: 52.9823,
    x2: 76.7952,
    y2: 101.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_13_259",
    x1: 159.769,
    y1: 498.654,
    x2: 166.192,
    y2: -141.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_13_259",
    x1: 160.159,
    y1: 498.654,
    x2: 166.581,
    y2: -141.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_13_259",
    x1: 160.548,
    y1: 498.654,
    x2: 166.971,
    y2: -141.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_13_259",
    x1: 263.53,
    y1: 499.689,
    x2: 269.952,
    y2: -140.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_13_259",
    x1: 263.929,
    y1: 499.689,
    x2: 270.351,
    y2: -140.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_13_259",
    x1: 264.319,
    y1: 499.699,
    x2: 270.741,
    y2: -140.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_13_259",
    x1: 163.171,
    y1: 87.0119,
    x2: 162.639,
    y2: 294.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_13_259",
    x1: 266.95,
    y1: 87.0119,
    x2: 266.418,
    y2: 294.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_13_259",
    x1: 163.171,
    y1: 126.238,
    x2: 162.639,
    y2: 333.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_13_259",
    x1: 266.95,
    y1: 126.238,
    x2: 266.418,
    y2: 333.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_13_259",
    x1: 163.171,
    y1: 165.474,
    x2: 162.639,
    y2: 373.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_13_259",
    x1: 266.95,
    y1: 165.474,
    x2: 266.418,
    y2: 373.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 306,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.33eb510aad3e7dc05e3e9a3449281380.svg";
export { ForwardRef as ReactComponent };